import React from 'react';
import { ActivityIndicator, Modal, ScrollView, TextInput, View } from 'react-native';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import type { Translate } from '../profileTypes';

export interface DeleteAccountForm {
  confirmation: string;
  reason: string;
}

interface DeleteAccountModalProps {
  visible: boolean;
  form: DeleteAccountForm;
  onChangeForm: (form: DeleteAccountForm) => void;
  loading: boolean;
  onCancel: () => void;
  onDelete: () => void;
  t: Translate;
}

export function DeleteAccountModal({
  visible,
  form,
  onChangeForm,
  loading,
  onCancel,
  onDelete,
  t,
}: DeleteAccountModalProps) {
  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View className="flex-1 bg-black/50 justify-center items-center p-4">
        <Card className="w-full max-w-sm" style={{ maxHeight: '90%' }}>
          <CardHeader className="pb-4">
            <Text className="text-xl font-semibold text-red-600 text-center">
              {t('profile.deleteAccountTitle')}
            </Text>
          </CardHeader>
          <ScrollView showsVerticalScrollIndicator contentContainerStyle={{ paddingBottom: 4 }}>
          <CardContent>
            <Card className="bg-red-50 border-l-4 border-l-red-500 mb-4">
              <CardContent className="p-3">
                <Text className="text-red-600 text-sm text-center">{t('profile.deleteWarning')}</Text>
              </CardContent>
            </Card>

            <TextInput
              className="border border-gray-300 rounded-lg px-4 py-3 mb-4 bg-gray-50 text-base"
              placeholder={t('profile.typeDeleteConfirm')}
              value={form.confirmation}
              onChangeText={(text) => onChangeForm({ ...form, confirmation: text })}
            />

            <TextInput
              className="border border-gray-300 rounded-lg px-4 py-3 mb-6 bg-gray-50 text-base"
              placeholder={t('profile.deletionReason')}
              value={form.reason}
              onChangeText={(text) => onChangeForm({ ...form, reason: text })}
              multiline
              numberOfLines={3}
              textAlignVertical="top"
              style={{ height: 80 }}
            />

            <View className="flex-row gap-3">
              <Button
                variant="secondary"
                size="default"
                onPress={onCancel}
                disabled={loading}
                className="flex-1"
              >
                <Text className="font-medium">{t('profile.cancel')}</Text>
              </Button>

              <Button variant="destructive" size="default" onPress={onDelete} disabled={loading} className="flex-1">
                {loading ? (
                  <ActivityIndicator color="white" />
                ) : (
                  <Text className="text-white font-medium">{t('profile.deleteAccount')}</Text>
                )}
              </Button>
            </View>
          </CardContent>
          </ScrollView>
        </Card>
      </View>
    </Modal>
  );
}
